export enum CorrugatedMaterialActionsTypes {
  READ = "@@CORRUGATED_MATERIAL read corrugated materials",
  READ_STATUS = "@@CORRUGATED_MATERIAL read status corrugated materials",
  CREATE = "@@CORRUGATED_MATERIAL create corrugated materials",
  CREATE_STATUS = "@@CORRUGATED_MATERIAL create status corrugated materials",
  UPDATE = "@@CORRUGATED_MATERIAL update corrugated materials",
  UPDATE_STATUS = "@@CORRUGATED_MATERIAL update status corrugated materials",
  EXPORT = "@@CORRUGATED_MATERIAL export status corrugated materials"
}
